import { render, staticRenderFns } from "./ExpenseTypeAdd.vue?vue&type=template&id=023dad12&scoped=true&"
import script from "./ExpenseTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ExpenseTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023dad12",
  null
  
)

export default component.exports